// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2SWMW","col":"styles_col__1Gq9h"};